import Board from './Board.js'

export default Board
